module.exports = __webpack_public_path__ + "img/add-check.2cd81559.png";